<template>
  <page>
    <!-- <maple-nav-bar
      left-arrow
      :safe-top-distance="statusBarHeight"
      title="美菜商城"
      @click-left="$back()"
    /> -->
    <tree />
    <activitys />
  </page>
</template>

<script>
import tree from './components/tree'
import activitys from './components/activitys'
import { navBar } from '@/utils/native_interactions/native_bar'
import { APP_CONFIG } from '@/defines/environment/config'
export default {
  name: 'PageMoneyTree',
  components: {
    tree,
    activitys
  },
  beforeRouteEnter(to, form, next) {
    next(vm => {
      navBar.setTitle({
        text: APP_CONFIG.app_name
      })
    })
  },
  onLogin() {
    window.location.reload()
  }
}
</script>
